import {
  Modal,
  Button,
  Divider,
  Switch,
  Checkbox,
  Row,
  Col,
  notification,
  Spin,
} from "antd";
import * as React from "react";
import { Layout, Input, TimePicker, Select } from "antd";
import { Formik, FieldProps, Field } from "formik";
import * as moment from "moment";
import styled from "styled-components";
import { findByEmail } from "../../Graphs/Employee/searchEmployee";
import { alertError } from "../../utils/alert";
import {
  emailValidation,
  mobileLengthValidation,
  mobileValidation,
  passwordValidation,
} from "../../utils/validations";
import { errorMessages } from "../../utils/validationMessages";
import { StyleSelect } from "../../assets/css/style";

const { Content } = Layout;
const Option = Select.Option;
const { TextArea } = Input;
var amenities = [];

const StyleDivider = styled(Divider)`
  &.ant-divider-horizontal {
    margin: 14px 0px;
  }
`;

const roles = [
  { label: "Admin", value: "Admin" },
  { label: "Employee", value: "Employee" },
  { label: "Accountant", value: "Accountant" },
];

export class AddEmployeeForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTime = this.handleTime.bind(this);
    this.handleCloseTime = this.handleCloseTime.bind(this);
    this.handleDetailsModalclose = this.handleDetailsModalclose.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      locationList: [],
      recordSelectedtoView: null,
      data: [],
      view: false,
      index: null,
      isLoading: false,
      popup: false,
      checked: false,
      item: null,
      filters: null,
      visible: false,
      inputVisible: false,
      inputValue: "",
      time: "",
      closeTime: "",
      closeTimeString: "",
      timeString: "",
      roleType: "1",
      selectedCoin: "",
      price: 0,
      errors: {},
      coinsList: [],
      role: roles,
      dashboard: {
        view: false,
        edit: false,
        delete: false,
      },
      master: {
        view: false,
        edit: false,
        delete: false,
      },
      card: {
        view: false,
        edit: false,
        delete: false,
      },
      user: {
        view: false,
        edit: false,
        delete: false,
      },
      balanceRequest: {
        view: false,
        edit: false,
        delete: false,
      },
      company: {
        view: false,
        edit: false,
        delete: false,
      },
      reports: {
        view: false,
        edit: false,
        delete: false,
      },
      sales: {
        view: false,
        edit: false,
        delete: false,
      },
      ticketSupport: {
        view: false,
        edit: false,
        delete: false,
      },
      expenses: {
        view: false,
        edit: false,
        delete: false,
      },
    };
  }

  input;

  componentDidMount() {
    if (this.props.refx) {
      this.props.refx(this);
    }
  }

  onChange(time, timeString) {
    console.log(time, timeString);
  }

  handleChange(value) {
    console.log(`selected ${value}`);
    amenities = value;
  }

  validateEmail = async (value) => {
    try {
      this.setState({
        isLoading: true,
      });

      let getEmployee = await findByEmail(this.props.authToken, value);
      this.setState({
        isLoading: false,
      });

      if (getEmployee.status == 200) {
        if (getEmployee.data == null) {
          return true;
        } else {
          notification["warn"]({
            message: "Email Validation",
            description: "Email is already in used",
          });
          return false;
        }
      } else {
        return -1;
      }
    } catch (error) {
      this.setState({
        isLoading: false,
      });

      alertError("Employee", error);

      return -1;
    }
  };

  validateForm(values) {
    const errors = {};
    console.log("Validating form -- ", values);

    if (!values.first_name) {
      errors.first_name = errorMessages.first_name_required;
    }
    if (!values.last_name) {
      errors.last_name = errorMessages.last_name_required;
    }

    if (!values.email) {
      errors.email = errorMessages.email_required;
    } else if (emailValidation(values.email)) {
      errors.email = errorMessages.email_validation;
    }

    if (values.role == "") {
      errors.role = "Please select one role";
    }

    if (!values.phone) {
      errors.phone = errorMessages.mobile_required;
    } else if (mobileLengthValidation(values.phone)) {
      errors.phone = errorMessages.mobile_length_validation;
    } else if (mobileValidation(values.phone)) {
      errors.phone = errorMessages.mobile_validation;
    }

    if (!values.password) {
      errors.password = errorMessages.password_required;
    } else if (passwordValidation(values.password)) {
      errors.password = errorMessages.password_validation;
    }

    console.log("Validating errors -- ", errors);
    return errors;
  }

  async handleSubmit(values, action) {
    console.log("values--", values);

    const {
      dashboard,
      master,
      sales,
      card,
      user,
      balanceRequest,
      ticketSupport,
      expenses,
      company,
      reports,
      errors,
    } = this.state;

    let listErrors = errors;
    console.log("sales", sales);
    let access = {
      dashboard: dashboard,
      user: user,
      master: master,
      card: card,
      balanceRequest: balanceRequest,
      company: company,
      reports: reports,
      sales: sales,
      ticketSupport: ticketSupport,
      expenses: expenses,
    };
    values.access_permission = JSON.stringify(access);

    let checkEmail = await this.validateEmail(values.email);

    if (checkEmail == false || checkEmail == -1) {
      if (checkEmail == false) {
        listErrors.email = "Email is already in used.";
        this.setState({
          errors: listErrors,
        });
        return;
      }
      return;
    }

    this.setState({
      errors: {},
    });

    let result = await this.props.onSubmit(values);

    if (result) {
      this.props.handleCancel();

      this.setState({
        visible: false,
      });
    }
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };

  handleTime(e, s) {
    this.setState({
      time: e,
      timeString: s,
    });
  }

  handleCloseTime(e, s) {
    this.setState({
      closeTime: e,
      closeTimeString: s,
    });
  }

  handleDetailsModalclose(item) {
    this.setState({
      view: false,
      lat: item.lat,
      long: item.lng,
    });
  }

  onChangeCoin = (value) => {
    this.setState({
      selectedCoin: value,
    });
  };

  onChangeCheckBox = (data, key) => {
    let obj = {};

    obj[key] = {
      view: data.includes("view"),
      edit: data.includes("edit"),
      delete: data.includes("delete"),
    };


    if (key == "dashboard") {
      this.setState({ defaultDashboard: data });
    } else if (key == "master") {
      this.setState({ defaultMaster: data });
    } else if (key == "card") {
      this.setState({ defaultCard: data });
    } else if (key == "user") {
      this.setState({ defaultUser: data });
    } else if (key == "balanceRequest") {
      this.setState({ defaultBalanceRequest: data });
    } else if (key == "company") {
      this.setState({ defaultCompany: data });
    } else if (key == "reports") {
      this.setState({ defaultReport: data });
    } else if (key == "sales") {
      this.setState({ defaultSales: data });
    } else if (key == "ticketSupport") {
      this.setState({ defaultTicketSupport: data });
    } else if (key == "expenses") {
      this.setState({ defaultExpenses: data });
    }
    else if (key == "inventoryBatch") {
      this.setState({ defaultInventoryBatch: data });
    }

    this.setState(obj);
  };

  handleSelectRole(value) {
    if (value == "Admin") {
      this.setState({
        dashboard: {
          view: true,
          edit: true,
          delete: true,
        },
        master: {
          view: true,
          edit: true,
          delete: true,
        },
        card: {
          view: true,
          edit: true,
          delete: true,
        },
        user: {
          view: true,
          edit: true,
          delete: true,
        },
        sales: {
          view: true,
          edit: true,
          delete: true,
        },
        ticketSupport: {
          view: true,
          edit: true,
          delete: true,
        },
        expenses: {
          view: true,
          edit: true,
          delete: true,
        },
        defaultDashboard: ["edit", "view", "delete"],
        defaultUser: ["edit", "view", "delete"],
        defaultCard: ["edit", "view", "delete"],
        defaultMaster: ["edit", "view", "delete"],
        defaultBalanceRequest: ["edit", "view", "delete"],
        defaultCompany: ["edit", "view", "delete"],
        defaultReport: ["edit", "view", "delete"],
        defaultSales: ["edit", "view", "delete"],
        defaultTicketSupport: ["edit", "view", "delete"],
        defaultExpenses: ["edit", "view", "delete"],
        defaultInventoryBatch: ["edit", "view", "delete"],
      });
    } else {
      this.setState({
        dashboard: {
          view: false,
          edit: false,
          delete: false,
        },
        master: {
          view: false,
          edit: false,
          delete: false,
        },
        card: {
          view: false,
          edit: false,
          delete: false,
        },
        user: {
          view: false,
          edit: false,
          delete: false,
        },
        ticketSupport: {
          view: false,
          edit: false,
          delete: false,
        },
        expenses: {
          view: false,
          edit: false,
          delete: false,
        },
        defaultDashboard: [],
        defaultUser: [],
        defaultCard: [],
        defaultMaster: [],
        defaultBalanceRequest: [],
        defaultCompany: [],
        defaultReport: [],
        defaultTicketSupport: [],
        defaultExpenses: [],
        defaultInventoryBatch: [],
      });
    }
  }

  render() {
    // const {  } = this.state;

    return (
      <div>
        <div>
          <Content style={{ background: "#fff", marginLeft: "10px" }}>
            <Formik
              initialValues={{
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
                password: "",
                role: "",
              }}
              validate={this.validateForm}
              onSubmit={this.handleSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldTouched,
                isSubmitting,
              }) => {
                return (
                  <div>
                    {this.state.isLoading ? (
                      <div style={{ justifyContent: "center" }}>
                        <Spin />
                      </div>
                    ) : (
                      <>
                        <div className="formik-field_wrap">
                          <div className="formik-field-left">
                            First Name
                            <Input
                              id="first_name"
                              placeholder="First Name"
                              value={values.first_name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {errors.first_name && touched.first_name ? (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "small",
                                  margin: "0",
                                }}
                              >
                                {errors.first_name}
                              </p>
                            ) : null}
                          </div>
                          <div className="formik-field-right">
                            Last Name
                            <Input
                              id="last_name"
                              placeholder="Last Name"
                              value={values.last_name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {errors.last_name && touched.last_name ? (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "small",
                                  margin: "0",
                                }}
                              >
                                {errors.last_name}
                              </p>
                            ) : null}
                          </div>
                        </div>
                        <div className="formik-field_wrap">
                          <div className="formik-field-left">
                            Phone
                            <Input
                              id="phone"
                              placeholder="User Phone"
                              value={values.phone}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {errors.phone && touched.phone ? (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "small",
                                  margin: "0",
                                }}
                              >
                                {errors.phone}
                              </p>
                            ) : null}
                          </div>
                          <div className="formik-field-right">
                            Email
                            <Input
                              id="email"
                              placeholder="Email"
                              value={values.email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {errors.email && touched.email ? (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "small",
                                  margin: "0",
                                }}
                              >
                                {errors.email}
                              </p>
                            ) : null}
                            {this.state.errors.email ? (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "small",
                                  margin: "0",
                                }}
                              >
                                {this.state.errors.email}
                              </p>
                            ) : null}
                          </div>
                        </div>

                        <div className="formik-field_wrap">
                          <div className="formik-field-left">
                            Password
                            <Input
                              id="password"
                              type="password"
                              placeholder="User Password"
                              value={values.password}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {errors.password && touched.password ? (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "small",
                                  margin: "0",
                                }}
                              >
                                {errors.password}
                              </p>
                            ) : null}
                          </div>
                          <div className="formik-field-right">
                            Role
                            <Select
                              value={values.role}
                              style={{ width: 200 }}
                              id="role"
                              name="role"
                              placeholder="Select Role"
                              onChange={(value) => {
                                setFieldValue("role", value);
                              }}
                              onBlur={() => setFieldTouched("role", true)}
                              onSelect={(value) => {
                                this.handleSelectRole(value);
                              }}
                              // options={this.state.role}
                              options={
                                this.props?.loginUserData?.role !== "Admin"
                                  ? this.state.role.filter((role) => role.value !== "Admin")
                                  : this.state.role
                              }

                            ></Select>
                            {errors.role && touched.role ? (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "small",
                                  margin: "0",
                                }}
                              >
                                {errors.role}
                              </p>
                            ) : null}
                          </div>
                        </div>
                        <div className="formik-field_wrap">

                          {/* {this.props?.loginUserData?.role != "Sub_admin" && (
                        <div className="formik-field-left">
                          City
                          <Field
                            name="cityName"
                            render={({ field }) => (
                              <StyleSelect
                                placeholder="Select City"
                                style={{ width: "100%" }}
                                name="cityName"
                                {...field}
                                onBlur={() => setFieldTouched("cityName", true)}
                                onSelect={(value, option) => {
                                  setFieldValue("cityName", value);
                                  setFieldValue("city", option.id);
                                }}
                                options={this.props.cityData}
                              />
                            )}
                          />
                        </div>
                      )} */}
                    
                     </div>
                        <hr />
                        <center>Access Permission</center>
                        <hr />
                        <div className="formik-field_wrap">
                          <div className="formik-field-left">
                            <hr />
                            Dashboard
                            <hr />
                            <Checkbox.Group
                              value={this.state.defaultDashboard}
                              style={{ width: "100%" }}
                              onChange={(e) =>
                                this.onChangeCheckBox(e, "dashboard")
                              }
                            >
                              <Row>
                                <Col span={7}>
                                  <Checkbox value="view">View</Checkbox>
                                </Col>
                                <Col span={7}>
                                  <Checkbox value="edit">Edit</Checkbox>
                                </Col>
                                <Col span={10}>
                                  <Checkbox value="delete">Delete</Checkbox>
                                </Col>
                              </Row>
                            </Checkbox.Group>
                          </div>
                          <div className="formik-field-right">
                            <hr />
                            User
                            <hr />
                            <Checkbox.Group
                              value={this.state.defaultUser}
                              defaultValue={this.state.defaultUser}
                              style={{ width: "100%" }}
                              onChange={(e) => this.onChangeCheckBox(e, "user")}
                            >
                              <Row>
                                <Col span={7}>
                                  <Checkbox value="view">View</Checkbox>
                                </Col>
                                <Col span={7}>
                                  <Checkbox value="edit">Edit</Checkbox>
                                </Col>
                                <Col span={10}>
                                  <Checkbox value="delete">Delete</Checkbox>
                                </Col>
                              </Row>
                            </Checkbox.Group>
                          </div>
                        </div>

                        <br />

                       
                          <div className="formik-field_wrap">
                            <div className="formik-field-left">
                              <hr />
                              Card
                              <hr />
                              <Checkbox.Group
                                value={this.state.defaultCard}
                                style={{ width: "100%" }}
                                onChange={(e) =>
                                  this.onChangeCheckBox(e, "card")
                                }
                              >
                                <Row>
                                  <Col span={7}>
                                    <Checkbox value="view">View</Checkbox>
                                  </Col>
                             
                                    <>
                                    <Col span={7}>
                                      <Checkbox value="edit">Edit</Checkbox>
                                    </Col>
                                    <Col span={10}>
                                      <Checkbox value="delete">Delete</Checkbox>
                                    </Col>
                                    </>
                                  
                                </Row>
                              </Checkbox.Group>
                            </div>
                            <div className="formik-field-right">
                              <hr />
                              Balance Request
                              <hr />
                              <Checkbox.Group
                                value={this.state.defaultBalanceRequest}
                                style={{ width: "100%" }}
                                onChange={(e) =>
                                  this.onChangeCheckBox(e, "balanceRequest")
                                }
                              >
                                <Row>
                                  <Col span={7}>
                                    <Checkbox value="view">View</Checkbox>
                                  </Col>
                                  <Col span={7}>
                                    <Checkbox value="edit">Edit</Checkbox>
                                  </Col>
                                  <Col span={10}>
                                    <Checkbox value="delete">Delete</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                            </div>
                            
                            
                       
                          </div>

                          {this.props.loginUserData.role != "Sub_admin" && (
                            
                          <div className="formik-field_wrap">
                          
                          
                          
                          
                        
                            <div className="formik-field-right">
                              <hr />
                              Master
                              <hr />
                              <Checkbox.Group
                                style={{ width: "100%" }}
                                value={this.state.defaultMaster}
                                onChange={(e) =>
                                  this.onChangeCheckBox(e, "master")
                                }
                              >
                                <Row>
                                  <Col span={7}>
                                    <Checkbox value="view">View</Checkbox>
                                  </Col>
                                  <Col span={7}>
                                    <Checkbox value="edit">Edit</Checkbox>
                                  </Col>
                                  <Col span={10}>
                                    <Checkbox value="delete">Delete</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                            </div>
                      
                          
                          
                          
                          
                          
                          
                           
                            <div className="formik-field-right">
                              <hr />
                              Company
                              <hr />
                              <Checkbox.Group
                                value={this.state.defaultCompany}
                                defaultValue={this.state.defaultUser}
                                style={{ width: "100%" }}
                                onChange={(e) =>
                                  this.onChangeCheckBox(e, "company")
                                }
                              >
                                <Row>
                                  <Col span={7}>
                                    <Checkbox value="view">View</Checkbox>
                                  </Col>
                                  <Col span={7}>
                                    <Checkbox value="edit">Edit</Checkbox>
                                  </Col>
                                  <Col span={10}>
                                    <Checkbox value="delete">Delete</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                            </div>
                        
                          </div>
                          )}

                        <div className="formik-field_wrap">
                          <div className="formik-field-left">
                            <hr />
                            Report
                            <hr />
                            <Checkbox.Group
                              value={this.state.defaultReport}
                              style={{ width: "100%" }}
                              onChange={(e) =>
                                this.onChangeCheckBox(e, "reports")
                              }
                            >
                              <Row>
                                <Col span={7}>
                                  <Checkbox value="view">View</Checkbox>
                                </Col>
                                <Col span={7}>
                                  <Checkbox value="edit">Edit</Checkbox>
                                </Col>
                                <Col span={10}>
                                  <Checkbox value="delete">Delete</Checkbox>
                                </Col>
                              </Row>
                            </Checkbox.Group>
                          </div>
                          <div className="formik-field-right">
                            <hr />
                            Sales
                            <hr />
                            <Checkbox.Group
                              value={this.state.defaultSales}
                              style={{ width: "100%" }}
                              onChange={(e) =>
                                this.onChangeCheckBox(e, "sales")
                              }
                            >
                              <Row>
                                <Col span={7}>
                                  <Checkbox value="view">View</Checkbox>
                                </Col>
                                <Col span={7}>
                                  <Checkbox value="edit">Edit</Checkbox>
                                </Col>
                                <Col span={10}>
                                  <Checkbox value="delete">Delete</Checkbox>
                                </Col>
                              </Row>
                            </Checkbox.Group>
                          </div>
                        </div>

                     
                          <div className="formik-field_wrap">
                            <div className="formik-field-left">
                              <hr />
                              Ticket Support
                              <hr />
                              <Checkbox.Group
                                value={this.state.defaultTicketSupport}
                                style={{ width: "100%" }}
                                onChange={(e) =>
                                  this.onChangeCheckBox(e, "ticketSupport")
                                }
                              >
                                <Row>
                                  <Col span={7}>
                                    <Checkbox value="view">View</Checkbox>
                                  </Col>
                                  <Col span={7}>
                                    <Checkbox value="edit">Edit</Checkbox>
                                  </Col>
                                  <Col span={10}>
                                    <Checkbox value="delete">Delete</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                            </div>
                            <div className="formik-field-right">
                              <hr />
                              Expenses
                              <hr />
                              <Checkbox.Group
                                value={this.state.defaultExpenses}
                                style={{ width: "100%" }}
                                onChange={(e) =>
                                  this.onChangeCheckBox(e, "expenses")
                                }
                              >
                                <Row>
                                  <Col span={7}>
                                    <Checkbox value="view">View</Checkbox>
                                  </Col>
                                  <Col span={7}>
                                    <Checkbox value="edit">Edit</Checkbox>
                                  </Col>
                                  <Col span={10}>
                                    <Checkbox value="delete">Delete</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                            </div>
                          </div>
                          <div className="formik-field_wrap">
                            <div className="formik-field-left">
                              <hr />
                              Inventory Batch
                              <hr />
                              <Checkbox.Group
                                value={this.state.defaultInventoryBatch}
                                style={{ width: "100%" }}
                                onChange={(e) =>
                                  this.onChangeCheckBox(e, "inventoryBatch")
                                }
                              >
                                <Row>
                                  <Col span={7}>
                                    <Checkbox value="view">View</Checkbox>
                                  </Col>
                                  <Col span={7}>
                                    <Checkbox value="edit">Edit</Checkbox>
                                  </Col>
                                  <Col span={10}>
                                    <Checkbox value="delete">Delete</Checkbox>
                                  </Col>
                                </Row>
                              </Checkbox.Group>
                            </div>
                    
                          </div>

                        <Button
                          // type="primary"
                          style={{
                            marginTop: "19px",
                            background: "#5C6AC4",
                            color: "#fff",
                          }}
                          onClick={handleSubmit}
                        >
                          Save
                        </Button>
                      </>
                    )}
                  </div>
                );
              }}
            </Formik>
          </Content>
        </div>
      </div>
    );
  }
}
